export default __webpack_public_path__ + "5c0ef5efacb825b6ae620cef1a168362.svg";